module.exports = __webpack_public_path__ + "img/insta9.ba74706d.jpg";